import React from "react";
import { TrendUp, TrendDown, ArrowSquareOut } from "@phosphor-icons/react";

/**
 * Tiny inline Bet button for compact rows (Alerts, etc).
 * Picks the side matching the AI's edge sign.
 *
 * Props: slug (string|null), marketId, edge (number)
 * If slug is missing the button silently renders nothing — fallback is the
 * row's main click target which already navigates to the market detail page
 * where the full BetButtons are available.
 */
export default function BetInline({ slug, marketId, edge = 0 }) {
  if (!slug) return null;
  const isYes = edge >= 0;
  const side = isYes ? "YES" : "NO";
  const url = `https://polymarket.com/market/${slug}?side=${side}&utm_source=mfsmai_oracle&utm_medium=alerts`;
  const Icon = isYes ? TrendUp : TrendDown;
  const cls = isYes
    ? "border-yes/60 text-yes hover:bg-yes hover:text-white"
    : "border-no/60 text-no hover:bg-no hover:text-white";
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={`bet-inline-${marketId}`}
      onClick={(e) => e.stopPropagation()}
      className={`inline-flex items-center gap-1 border px-2 py-1 text-[10px] font-mono uppercase tracking-widest transition-colors ${cls}`}
      title={`Bet ${side} on Polymarket · AI edge ${edge >= 0 ? "+" : ""}${(edge * 100).toFixed(0)}%`}
    >
      <Icon size={10} weight="bold" />
      Bet {side}
      <ArrowSquareOut size={9} />
    </a>
  );
}
